/**
 * Browser storage keys this app no longer reads, removed once at start-up
 * so they do not linger (and cannot be mistaken for a live setting).
 *
 * - comms_demo_mode: the header's Demo toggle, removed with demo mode; the
 *   AI tools always use the configured model now.
 * - comms_nav_collapsed: whether the sidebar was collapsed to an icon rail.
 *   The sidebar no longer collapses (it always shows in full on a wide
 *   screen), so a stored "true" is removed rather than left to look live.
 */
export const LEGACY_STORAGE_KEYS = ['comms_demo_mode', 'comms_nav_collapsed']

/**
 * Remove the legacy keys. Storage that is blocked (a private window, a
 * sandbox) is left alone: there is nothing to clean up there anyway.
 */
export const clearLegacyStorage = () => {
    LEGACY_STORAGE_KEYS.forEach((key) => {
        try {
            window.localStorage.removeItem(key)
        } catch {
            // Storage blocked: nothing stored, nothing to remove.
        }
    })
}
